var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default (function (data) {
    var merge = function (aggregator, item, index) {
        var _a;
        return (__assign(__assign({}, aggregator), (_a = {}, _a[item.id] = index, _a)));
    };
    var index = -1;
    return data.reduce(function (aggregator, x) {
        if ('items' in x) {
            return x.items.reduce(function (itemAg, z) {
                index = index + 1;
                return merge(itemAg, z, index);
            }, aggregator);
        }
        index = index + 1;
        return merge(aggregator, x, index);
    }, {});
});
